import {
  INIT,
  SET_FETCH_PARAMS,
  FETCH_SUCCESS,
  FETCH_FAILED,
  VERIFY,
  VERIFY_SUCCESS,
  VERIFY_FAILED,
  SEND_PAC_UPLOAD_EMAIL_NOTIFICATION,
  SEND_PAC_UPLOAD_EMAIL_NOTIFICATION_SUCCESS,
  SEND_PAC_UPLOAD_EMAIL_NOTIFICATION_FAILED,
} from './constants';

export const initAction = () => ({
  type: INIT,
});

export const fetchFailedAction = (error) => ({
  type: FETCH_FAILED,
  error,
});
export const fetchSuccessAction = (error) => ({
  type: FETCH_SUCCESS,
  error,
});

export const setFetchParamsAction = (params) => ({
  type: SET_FETCH_PARAMS,
  params,
});

export const verifyAction = (state, userId) => ({
  type: VERIFY,
  state,
  userId,
});

export const verifySuccessAction = (userId) => ({
  type: VERIFY_SUCCESS,
  userId,
});

export const verifyFailedAction = (error, userId) => ({
  type: VERIFY_FAILED,
  error,
  userId,
});

export interface SendPacUploadEmailAction {
  type: typeof SEND_PAC_UPLOAD_EMAIL_NOTIFICATION;
  message: string;
}
export const sendPacUploadEmailAction = (message: string): SendPacUploadEmailAction => ({
  type: SEND_PAC_UPLOAD_EMAIL_NOTIFICATION,
  message,
});
export const sendPacUploadEmailSuccessAction = () => ({
  type: SEND_PAC_UPLOAD_EMAIL_NOTIFICATION_SUCCESS,
});
export const sendPacUploadEmailFailedAction = (error: object) => ({
  type: SEND_PAC_UPLOAD_EMAIL_NOTIFICATION_FAILED,
  error,
});
